import { nanoid } from "@reduxjs/toolkit";
import { routes } from "../../app/paths";
import { CoreUserType } from "../user/types/entities";
import { getCoreUsers } from "../user/userAPI";
import { getCustomerOrganizations } from "./customerAPI";
import { CustomerUserAccount } from "./types/queries";

export const getCustomerBasicInfoPath = async (
  customerUserId: string,
): Promise<string | null> => {
  // Two queries: core user (company id) then organizations (representative org).
  // Optimize later with a dedicated query if this becomes a hotspot.
  const { data } = await getCoreUsers(
    { type: CoreUserType.CUSTOMER, userIds: [customerUserId] },
    { requestId: nanoid() },
  );
  const companyId = (
    data.find((user) => user.id === customerUserId)?.account as
      | CustomerUserAccount
      | undefined
  )?.customerUserCompanyId;
  if (!companyId) return null;

  const orgs = await getCustomerOrganizations(
    { companyId },
    { requestId: nanoid() },
  );
  const org = orgs.find((item) => item.isRepresentative);
  if (!org?.id) return null;

  return routes.customerBasicInfo(companyId, { org: org.id });
};
